var _module_exports = "<page-header title=\"'Event list'\" breadcrumbs=\"['Events']\" reload=\"true\"> </page-header>\n\n<docker-events-datatable dataset=\"events\"></docker-events-datatable>\n";;
var path = 'app/docker/views/events/events.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;